<template>
  <div>
    <b-card
      v-if="$can('read', 'Analytics')"
      title="Super Admin's Dashboard 🚀"
    >
      <b-card-text>Super Admin related stuff</b-card-text>
    </b-card>

    <b-card
      v-if="!$can('no-access', 'not-allowed')"
      title="Bookkeeper related Stuff 🔒"
    >
      <b-card-text>Bookkeeper related stuff.</b-card-text>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    // BLink,
  },
}
</script>

<style>

</style>
